import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { EMPTY } from 'rxjs';
import { catchError, take } from 'rxjs/operators';

import { LoadingService } from '@finder/shared/services/loading-service/loading-service.service';
import { AiSearchService } from '@finder/features/ai-search/services/ai-search/ai-search.service';
import { FinderSeoService } from '@finder/shared/services/finder-seo/finder-seo.service';
import { SeoService } from '@wdpr/ra-angular-seo-metadata';

@Injectable()
export class AiSearchResolver implements Resolve<any> {

    constructor(
        private loadingService: LoadingService,
        private aiSearchService: AiSearchService,
        private seoService: SeoService,
        private finderSeoService: FinderSeoService,
    ) { }

    resolve(route: ActivatedRouteSnapshot) {
        // Here we call the services to get the data ready
        // for the search page

        // Reset of Error state to avoid getting Error message stuck after back button pressed GIT-31197
        this.loadingService.setErrorState(null);
        this.loadingService.setLoadingState(false);

        return new Promise((resolve) => {
            this.aiSearchService.init()
                .pipe(
                    catchError((error) => {
                        this.loadingService.setErrorState(error);
                        this.loadingService.setLoadingState(true);

                        // Is needed resolve the promise so the url redirection will be carried out
                        // when we want to show our error messaging page
                        resolve(error);

                        // This doesn't really do anything other an stop the error from a
                        // method that wants an Observable returned to it
                        return EMPTY;
                    }),
                    take(1)
                ).subscribe(result => {
                    // Set SEO
                    if (result.meta) {
                        this.seoService.setSeoData(result.meta);
                    } else {
                        this.finderSeoService.getPageKeyAndSetSeo();
                    }

                    resolve(result);
                });
        });
    }
}
